import React from 'react';

// import components
import LightImageCards from 'components/partials/light-image-cards';

// import types
import { ImageContentCardData } from "types/image-content-card-data";

// import helpers
import { isGatsbyImageData } from "helpers/is-gatsby-image";
import { getLinkDataFromDato } from "helpers/get-link-data";

const CardsWithDescriptionsCollectionBuilder: React.FC<{ cardsWithDescriptionsCollectionData?: Queries.CardsWithDescriptionsCollectionBlockFragment }> = ({ cardsWithDescriptionsCollectionData }) => {

    if (!cardsWithDescriptionsCollectionData) return null;

    let headline = "Error: No headline provided.";

    if (cardsWithDescriptionsCollectionData.heading) {
        headline = cardsWithDescriptionsCollectionData.heading;
    }

    let linkData = getLinkDataFromDato(cardsWithDescriptionsCollectionData.link?.link);

    const intro = {
        headline: headline,
        buttonProps: linkData ? {
            buttonText: linkData?.label || 'Error: Missing label',
            buttonUrl: linkData?.url || '#',
            buttonUrlTarget: linkData?.target || '_self',
        } : undefined
    };

    let imageCardColumns = 3;

    if (cardsWithDescriptionsCollectionData.cardSize === 'large') {
        imageCardColumns = 2;
    }

    const cards: ImageContentCardData[] = cardsWithDescriptionsCollectionData.cards?.map((card): ImageContentCardData | undefined => {
        if (!card) return undefined;

        // provides with info for front-end url, button text, and button target
        // also provides with info for the card's title, description, and image
        let linkData = getLinkDataFromDato(card.link?.link);

        let cardHeadline = linkData?.title || 'Error: missing title';
        let cardSubtext = linkData?.shortDescription || '';
        if (card.headingOverride) cardHeadline = card.headingOverride;
        if (card.descriptionOverride) cardSubtext = card.descriptionOverride;

        let cardImage = linkData?.carouselCardImage || undefined;
        if (card.imageOverride && typeof card.imageOverride === 'object') {
            cardImage = isGatsbyImageData(card.imageOverride.gatsbyImageData) ? card.imageOverride.gatsbyImageData : undefined;
        }

        let cardImageAlt = card.imageOverride?.alt || '';

        return {
            id: card.id,
            cardImage: cardImage,
            cardImageAlt: cardImageAlt,
            headline: cardHeadline,
            subtext: cardSubtext,
            buttonText: linkData?.label || 'Error: Missing label',
            buttonUrl: linkData?.url || '#',
            buttonUrlTarget: linkData?.target || '_self',
        };
    }).filter((card): card is ImageContentCardData => card !== undefined) || [];

    return (
        <LightImageCards
            intro={intro}
            cards={cards}
            columns={imageCardColumns}
        />
    );

}

export default CardsWithDescriptionsCollectionBuilder;